export default function MyDivider({ label = "" }) {
  return (
    <div className="flex items-center justify-center my-4">
      <hr className="flex-grow border-gray-300 dark:border-gray-600" />
      {label && <span className="mx-3 text-gray-500 dark:text-gray-400">{label}</span>}
      <hr className="flex-grow border-gray-300 dark:border-gray-600" />
    </div>
  );
}